import { faEye, faMars, faVenus, faEdit, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"
import { Link } from "react-router-dom"
import { numFixer } from "../../../User/getAllUsers/components/Functions"

export const columnConfig = ({
  renderStatePayload,
  applicationStateLabels,
  handleUpdateApplication,
  handleUpdateAddress,
  handleUpdatePricing,
}) => [
  { accessor: "id", title: "Id", sortable: true },
  {
    accessor: "campaign",
    title: "Kampanya",
    sortable: true,
    render: ({ campaign }) => {
      if (!campaign) {
        return <div className="text-center items-center mr-4">No Campaign</div>
      }
      return (
        <Link to={`/campaigns/find/${campaign}`}>
          <div className="text-center items-center mr-4">
            <FontAwesomeIcon icon={faEye} style={{ color: "#005eff" }} />
          </div>
        </Link>
      )
    },
  },
  {
    accessor: "user",
    title: "Kullanıcı",
    sortable: true,
    render: ({ user }) => {
      if (!user) {
        return <div className="text-center items-center mr-4">No User</div>
      }

      return (
        <Link to={`/user/find/${user}`}>
          <div className="text-center items-center mr-4">
            <FontAwesomeIcon icon={faEye} style={{ color: "#005eff" }} />
          </div>
        </Link>
      )
    },
  },
  {
    accessor: "brandName",
    title: "Marka Adı",
    sortable: true,
  },
  {
    accessor: "campaignName",
    title: "Kampanya Adı",
    sortable: true,
  },
  {
    accessor: "insta_full_name",
    title: "IG Tam İsim",
    sortable: true,
  },
  {
    accessor: "email",
    title: "Email",
    sortable: true,
  },
  {
    accessor: "state",
    title: "State",
    sortable: true,
    render: ({ state }) => applicationStateLabels[state] || state,
  },
  {
    accessor: "application_date",
    title: "Başvuru Tarihi",
    sortable: true,
    render: ({ application_date }) =>
      application_date
        ? new Date(application_date).toLocaleString("tr-TR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
          })
        : "N/A",
  },
  {
    accessor: "state_payload",
    title: "State Payload",
    sortable: true,
    render: renderStatePayload,
  },
  {
    accessor: "price_user",
    title: "Kullanıcı Tutarı",
    sortable: true,
    render: ({ price_user, price_brand, ...record }) => (
      <div className="flex flex-col items-center justify-center">
        <span>{price_user}</span>
        <button
          className="text-indigo-600 bg-indigo-100 rounded px-2 py-1 mt-1 text-xs"
          onClick={() => handleUpdatePricing({ price_user, price_brand, ...record })}
        >
          Düzenle
        </button>
      </div>
    ),
  },
  {
    accessor: "price_brand",
    title: "Marka Tutarı",
    sortable: true,
    render: ({ price_user, price_brand, ...record }) => (
      <div className="flex flex-col items-center justify-center">
        <span>{price_brand}</span>
        <button
          className="text-indigo-600 bg-indigo-100 rounded px-2 py-1 mt-1 text-xs"
          onClick={() => handleUpdatePricing({ price_user, price_brand, ...record })}
        >
          Düzenle
        </button>
      </div>
    ),
  },
  {
    accessor: "age",
    title: "Yaş",
    sortable: true,
    render: ({ age }) => <div>{age > 65 ? "65" : age}</div>,
  },
  {
    accessor: "gender",
    title: "Cinsiyet",
    sortable: true,
    render: ({ gender }) => (
      <div className="text-center items-center">
        {gender === "male" ? (
          <FontAwesomeIcon icon={faMars} style={{ color: "#005eff" }} />
        ) : gender === "female" ? (
          <FontAwesomeIcon icon={faVenus} style={{ color: "#ff00dd" }} />
        ) : (
          <div>diğer</div>
        )}
      </div>
    ),
  },
  {
    accessor: "verification",
    title: "Onay Durumu",
    sortable: true,
    render: (verification) => (verification ? "True" : "False"),
  },
  { accessor: "job", title: "Meslek", sortable: true },
  { accessor: "country", title: "Ülke", sortable: true },
  {
    accessor: "insta_username",
    title: "Insta Kullanıcı Adı",
    sortable: true,
    render: ({ insta_username }) => (
      <a
        href={`https://www.instagram.com/${insta_username}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="text-center items-center">
          <span>{insta_username}</span>
        </div>
      </a>
    ),
  },
  {
    accessor: "tiktok_username",
    title: "TikTok Kullanıcı Adı",
    sortable: true,
    render: ({ tiktok_username }) => (
      <a
        href={`https://www.tiktok.com/@${tiktok_username}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="text-center items-center">
          <span>{tiktok_username}</span>
        </div>
      </a>
    ),
  },
  {
    accessor: "insta_followers",
    title: "Insta Takipçi",
    sortable: true,
  },
  {
    accessor: "insta_average_like",
    title: "Insta Ortalama Beğeni",
    sortable: true,
  },
  {
    accessor: "insta_post_number",
    title: "Insta Gönderi Sayısı",
    sortable: true,
  },
  {
    accessor: "tiktok_followers",
    title: "TikTok Takipçi",
    sortable: true,
  },
  {
    accessor: "tiktok_average_like",
    title: "TikTok Ortalama Beğeni",
    sortable: true,
  },
  {
    accessor: "tiktok_engagement_rate",
    title: "TikTok Etkileşim Oranı",
    sortable: true,
    render: ({ tiktok_engagement_rate }) => <div>{numFixer(tiktok_engagement_rate)}</div>,
  },
  {
    accessor: "tiktok_hearts",
    title: "TikTok Kalp Sayısı",
    sortable: true,
  },
  {
    accessor: "actions",
    title: "İşlemler",
    sortable: false,
    render: (record) => (
      <div className="flex items-center justify-center space-x-2">
        <button
          onClick={() => handleUpdateApplication(record)}
          className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
          title="Başvuruyu Güncelle"
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
        <button
          onClick={() => handleUpdateAddress(record)}
          className="px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
          title="Adres Güncelle"
        >
          <FontAwesomeIcon icon={faMapMarkerAlt} />
        </button>
      </div>
    ),
  },
]
